import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  from: 'From Account',
  nickname: 'BPAY Nickname',
  biller: 'Biller Code',
  billerName: 'Biller Name',
  crn: 'CRN',
})
